import React, { FC } from 'react';

import { Close24 } from '../../icons';
import { IconButton, IconButtonProps } from '../IconButton';


const buttonOffsetBySize: Record<Extract<IconButtonProps['size'], 'small' | 'medium'>, number> = {
    small: 4,
    medium: 6,
};
interface CloseModalButtonProps extends IconButtonProps {
    absolute?: boolean;
    withBorder?: boolean;
}

export const CloseModalButton: FC<CloseModalButtonProps> = ({
    onClick,
    size = 'medium',
    variant = 'secondary',
    absolute = true,
    withBorder,
    ...props
}) => (
    <IconButton
        onClick={onClick}
        isRound
        variant={variant}
        size={size}
        sx={({ spacing }) => ({
            ...withBorder ? {
                border: 1,
                borderColor: 'grayscale.shade80',
            } : {},
            ...absolute ? {
                position: 'absolute',
                top: spacing(buttonOffsetBySize[size]),
                right: spacing(buttonOffsetBySize[size]),
                zIndex: 1,
            } : {},
        })}
        {...props}
    >
        <Close24 />
    </IconButton>
);
